import React from "react";
import { Breadcrumbs, createStyles, Container, Skeleton } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  root: {
    color: "white",
    fontSize: "16px",
    lineHeight: "25px",
    textDecoration: "none",
  },
  separator: {
    color: "white",
    fontSize: "16px",
  },
}));

const SinglePageHeaderSkeleton = () => {
  const { classes } = useStyles();

  const breadLinks = Array.from(Array(3)).map((item, index) => (
    <Skeleton key={index} height={25} width={120} />
  ));

  return (
    <section className="bg-gradient-to-r from-lightPrimary to-darkPrimary ">
      <Container className="relative min-h-[300px]">
        <Breadcrumbs
          className="font-bold absolute top-5 max-w-[300px]"
          classNames={{
            separator: classes.separator,
          }}
        >
          {breadLinks}
        </Breadcrumbs>
        <div className="flex items-center">
          <div className="mt-24 mb-10 ">
            <Skeleton height={96} className="max-w-[600px]" />
            <Skeleton
              mt={8}
              mb={4}
              height={20}
              width={300}
              className="sm:w-[600px]"
            />
            <Skeleton my={4} height={20} width={300} className="sm:w-[600px]" />
            <Skeleton my={4} height={20} width={300} className="sm:w-[600px]" />
          </div>
          <div className={`hidden lg:block absolute right-0 bottom-[-80px]`}>
            <Skeleton height={250} width={400} />
          </div>
        </div>
      </Container>
    </section>
  );
};
export default SinglePageHeaderSkeleton;
